import React__default from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import clsx from 'clsx';

var ThumbnailGeneratorTabs;
(function (ThumbnailGeneratorTabs) {
    ThumbnailGeneratorTabs[ThumbnailGeneratorTabs["PointOfInterest"] = 0] = "PointOfInterest";
    ThumbnailGeneratorTabs[ThumbnailGeneratorTabs["Crop"] = 1] = "Crop";
})(ThumbnailGeneratorTabs || (ThumbnailGeneratorTabs = {}));
var ThumbnailGeneratorTabsComponent = function TabsComponent(_a) {
    var tabsItem = _a.tabsItem, onChange = _a.onChange, _b = _a.selectedTab, selectedTab = _b === void 0 ? ThumbnailGeneratorTabs.PointOfInterest : _b, KIcon = _a.KIcon, className = _a.className, id = _a.id;
    if (!tabsItem || tabsItem.length < 2) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return (React__default.createElement(Box, { sx: { width: "100%" } },
        React__default.createElement(Box, { "data-testid": "TabsTestId", sx: { borderBottom: function (theme) { return "1px solid ".concat(theme.palette.grey[300]); } } },
            React__default.createElement(Tabs, { id: id, className: clsx("ThumbnailGeneratorTabsComponent", className), value: selectedTab, onChange: function (_, newValue) {
                    if (onChange) {
                        onChange(newValue);
                    }
                }, textColor: "inherit", sx: {
                    backgroundColor: function (theme) { return theme.palette.grey[100]; }
                } }, tabsItem &&
                tabsItem.length > 0 &&
                tabsItem.map(function (t) { return (React__default.createElement(Tab, { sx: { width: "".concat(100 / tabsItem.length, "%") }, icon: React__default.createElement(KIcon, { sx: {
                            fontSize: "2em"
                        }, className: "".concat(t.icon) }), label: t.name, key: t.name })); })))));
};

export { ThumbnailGeneratorTabs, ThumbnailGeneratorTabsComponent as default };
//# sourceMappingURL=index.js.map
